module.exports = __webpack_public_path__ + "static/img/z1.0a50284b.png";